import { render, staticRenderFns } from "./shift-view-modal.vue?vue&type=template&id=32f559e5&scoped=true"
import script from "./shift-view-modal.vue?vue&type=script&lang=js"
export * from "./shift-view-modal.vue?vue&type=script&lang=js"
import style0 from "./shift-view-modal.vue?vue&type=style&index=0&id=32f559e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f559e5",
  null
  
)

export default component.exports